import { z } from 'zod';

const levelsSchema = z.preprocess((levels) => {
    if (typeof levels !== 'object' || levels === null) return {};
    const out: Record<string, boolean> = {};
    for (const [key, value] of Object.entries(levels)) {
        if (typeof key === 'string' && typeof value === 'boolean') {
            out[key] = value;
        }
    }
    return out;
}, z.record(z.string(), z.boolean()).default({}).catch({}));

const defaultLevels = levelsSchema.parse({});

export const filtersParamsSchema = z.object({
    progress_only: z.boolean().default(false).catch(false),
    levels: levelsSchema.default(defaultLevels).catch(defaultLevels),
});

const defaultFilters = filtersParamsSchema.parse({});

export type filtersParamsType = z.infer<typeof filtersParamsSchema>;

export const packsParamsSchema = z.object({
    search: z.string().max(100).default('').catch(''),
    sort: z.enum(['name', 'points']).default('name').catch('name'),
    reverse: z.boolean().default(false).catch(false),
    filters: filtersParamsSchema.default(defaultFilters).catch(defaultFilters),
});

export type packsParamsType = z.infer<typeof packsParamsSchema>;

export const defaultPacksParams = packsParamsSchema.parse({});
